import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "xiangbei-close",
  "use": "xiangbei-close-usage",
  "viewBox": "0 0 14 15",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 15\" id=\"xiangbei-close\"><path d=\"m7.708 7.5 3.589-4.278a.109.109 0 0 0-.084-.179h-1.09a.223.223 0 0 0-.169.078L6.994 6.65l-2.96-3.53a.218.218 0 0 0-.168-.077h-1.09a.109.109 0 0 0-.084.18L6.28 7.5l-3.59 4.278a.11.11 0 0 0 .025.162.109.109 0 0 0 .06.017h1.09a.223.223 0 0 0 .168-.078l2.96-3.529 2.96 3.53a.222.222 0 0 0 .168.077h1.091a.109.109 0 0 0 .084-.18L7.708 7.5Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol